export default __webpack_public_path__ + "static/ceo-7c30df364e1f442d6b47fbb4ae82763d.png";